import { useEffect, useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { StatsGrid } from "../components/StatsGrid";
import { Slip } from "../components/Slip";
import { Regolamento } from "../components/Regolamento";
import { NicknameEditor } from "../components/NicknameEditor";

const STATUS = { open: "aperta", live: "in corso", suspended: "sospesa", scored: "conclusa" };

export default function ProfilePage() {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);
  const [tournaments, setTournaments] = useState(null);
  const [tid, setTid] = useState(null);
  const [hist, setHist] = useState(null);

  useEffect(() => {
    api.get("/me/stats").then((r) => setStats(r.data)).catch(() => {});
    api.get("/tournaments").then((r) => { setTournaments(r.data); setTid(r.data[0]?.id || null); }).catch(() => setTournaments([]));
  }, []);

  useEffect(() => {
    if (!tid) return;
    setHist(null);
    api.get("/me/history", { params: { tid } }).then((r) => setHist(r.data)).catch(() => setHist({ rounds: [] }));
  }, [tid]);

  return (
    <div className="space-y-10">
      <section className="fade-up">
        <p className="font-mono text-xs uppercase tracking-widest text-emerald-400">Il tuo profilo</p>
        <NicknameEditor />
        <p className="text-slate-400 mt-1">{user?.email}</p>
      </section>
      <StatsGrid stats={stats} />
      <section className="space-y-5">
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
          <h2 className="font-display text-2xl font-extrabold uppercase tracking-tight">Storico schedine</h2>
          {tournaments?.length > 0 && (
            <div className="w-full sm:w-72">
              <Select value={tid || undefined} onValueChange={setTid}>
                <SelectTrigger data-testid="history-tournament-select" className="h-11 bg-[#121824] border-[#26334D]"><SelectValue /></SelectTrigger>
                <SelectContent className="bg-[#121824] border-[#26334D]">
                  {tournaments.map((t) => <SelectItem key={t.id} value={t.id} data-testid={`history-tournament-${t.id}`}>{t.name}</SelectItem>)}
                </SelectContent>
              </Select>
            </div>
          )}
        </div>
        {tournaments?.length === 0 && <p className="card-surface p-8 text-slate-400">Non partecipi ancora a nessun torneo.</p>}
        {tid && !hist && <div className="card-surface h-40 animate-pulse" />}
        {hist?.rounds.length === 0 && <p className="card-surface p-8 text-slate-400" data-testid="history-empty">Nessuna schedina consegnata in questo torneo.</p>}
        <div className="grid md:grid-cols-2 gap-4" data-testid="history-list">
          {hist?.rounds.map((r) => (
            <Slip key={r.key} title={`${r.label} · ${STATUS[r.status]}`} slip={r} testId={`history-round-${r.key}`} />
          ))}
        </div>
      </section>
      <div id="regolamento"><Regolamento /></div>
    </div>
  );
}
